<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Stat from '@components/widget-stat'
import Overview from '@components/overview'

export default {
	page: {
		title: 'Статистика',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: {
		VuePerfectScrollbar,
		Layout,
		Overview,
        Stat,
	},

	data() {
		return {
			maxHeight: '328px',
            isCompany: false,
            isAdmin: false,
            load: true,
            state: 0
		}
	},

    computed: {
        OVERVIEW_DATA() {
            let data = this.$store.getters['statistics/GET_OVERVIEW_DATA'];

            let calls_qnt = 0;
            let users_qnt = 0;
            let balance = 0 + ' руб.';

            if(data !== null) {
                if (data.calls_qnt) calls_qnt = data.calls_qnt;
                if (data.users_qnt) users_qnt = data.users_qnt;
                if (data.balance) balance = data.balance + ' руб.';
            }

            return [
                {
                    class: 'border-bottom py-4',
                    icon: 'uil-users-alt',
                    value: users_qnt,
                    title: 'Количество контактов',
                },
                {
                    class: 'border-bottom py-4',
                    icon: 'uil-phone',
                    value: calls_qnt,
                    title: 'Количество звонков',
                },
                {
                    class: 'py-4',
                    icon: 'uil-wallet',
                    value: balance,
                    title: 'Текущий баланс',
                },
            ]
        },

        REVENUE_AREA_CHART() {

            let data = this.$store.getters['statistics/GET_REVENUE_AREA_CHART'];

            let categories = [];
            let series = [];

            if(data !== null) {
                if (data.months) {
                    categories = data.months;
                }

                if (data.values) {
                    series = data.values;
                }
            }

            return {
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: false,
                        },
                    },
                    tooltip: {
                        theme: 'dark',
                        x: {show: false},
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 4,
                    },
                    zoom: {
                        enabled: false,
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    legend: {
                        show: false,
                    },
                    colors: ['#43d39e'],
                    xaxis: {
                        type: 'string',
                        categories: categories,
                        tooltip: {
                            enabled: false,
                        },
                        axisBorder: {
                            show: false,
                        },
                    },
                    yaxis: {
                        labels: {
                            formatter(val) {
                                return val
                            },
                        },
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            type: 'vertical',
                            shadeIntensity: 1,
                            inverseColors: false,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [45, 100],
                        },
                    },
                },
                series: [
                    {
                        name: this.isAdmin ? 'Доходы' : 'Расходы',
                        data: series,
                    },
                ],
            }
        },

        PARTNERS_COMMISSIONS_AREA_CHART() {

            let data = this.$store.getters['statistics/GET_PARTNERS_COMMISSIONS_AREA_CHART'];

            let categories = [];
            let series = [];

            if(data !== null) {
                if (data.months) {
                    categories = data.months;
                }

                if (data.values) {
                    series = data.values;
                }
            }

            return {
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: false,
                        },
                    },
                    tooltip: {
                        theme: 'dark',
                        x: {show: false},
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 4,
                    },
                    zoom: {
                        enabled: false,
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    legend: {
                        show: false,
                    },
                    colors: ['#ffb02e'],
                    xaxis: {
                        type: 'string',
                        categories: categories,
                        tooltip: {
                            enabled: false,
                        },
                        axisBorder: {
                            show: false,
                        },
                    },
                    yaxis: {
                        labels: {
                            formatter(val) {
                                return val
                            },
                        },
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            type: 'vertical',
                            shadeIntensity: 1,
                            inverseColors: false,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [45, 100],
                        },
                    },
                },
                series: [
                    {
                        name: 'Вознаграждение',
                        data: series,
                    },
                ],
            }
        },

        EXPENSES_AREA_CHART() {

            let data = this.$store.getters['statistics/GET_EXPENSES_AREA_CHART'];

            let categories = [];
            let series = [];

            if(data !== null) {
                if (data.months) {
                    categories = data.months;
                }

                if (data.values) {
                    series = data.values;
                }
            }

            return {
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: false,
                        },
                    },
                    tooltip: {
                        theme: 'dark',
                        x: {show: false},
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 4,
                    },
                    zoom: {
                        enabled: false,
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    legend: {
                        show: false,
                    },
                    colors: ['#E26A4F'],
                    xaxis: {
                        type: 'string',
                        categories: categories,
                        tooltip: {
                            enabled: false,
                        },
                        axisBorder: {
                            show: false,
                        },
                    },
                    yaxis: {
                        labels: {
                            formatter(val) {
                                return val
                            },
                        },
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            type: 'vertical',
                            shadeIntensity: 1,
                            inverseColors: false,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [45, 100],
                        },
                    },
                },
                series: [
                    {
                        name: 'Затраты',
                        data: series,
                    },
                ],
            }
        },
        PAYMENT_AREA_CHART() {

            let data = this.$store.getters['statistics/GET_PAYMENT_AREA_CHART'];

            let categories = [];
            let series = [];

            if(data !== null) {
                if (data.months) {
                    categories = data.months;
                }

                if (data.values) {
                    series = data.values;
                }
            }

            return {
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: false,
                        },
                    },
                    tooltip: {
                        theme: 'dark',
                        x: {show: false},
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 4,
                    },
                    zoom: {
                        enabled: false,
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    legend: {
                        show: false,
                    },
                    colors: ['#489DC2'],
                    xaxis: {
                        type: 'string',
                        categories: categories,
                        tooltip: {
                            enabled: false,
                        },
                        axisBorder: {
                            show: false,
                        },
                    },
                    yaxis: {
                        labels: {
                            formatter(val) {
                                return val
                            },
                        },
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            type: 'vertical',
                            shadeIntensity: 1,
                            inverseColors: false,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [45, 100],
                        },
                    },
                },
                series: [
                    {
                        name: 'Сумма',
                        data: series,
                    },
                ],
            }
        },

        TARGET_BAR_CHART() {
            let data = this.$store.getters['statistics/GET_TARGET_BAR_CHART'];

            let categories = [];
            let series = [[], []];

            if (data !== null) {
                if (data.months) {
                    categories = data.months;
                }
                if (series[0]) {
                    series[0] = data.values[0];
                }
                if (series[1]) {
                    series[1] = data.values[1];
                }
            }

            return {
                chartOptions: {
                    colors: ['#43d39e', '#fad243'],
                    chart: {
                        type: 'bar',
                        stacked: true,
                        toolbar: {
                            show: false,
                        },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '45%',
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent'],
                    },
                    xaxis: {
                        categories: categories,
                        axisBorder: {
                            show: false,
                        },
                    },
                    legend: {
                        show: false,
                    },
                    grid: {
                        row: {
                            colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                            opacity: 100,
                        },
                        borderColor: '#f3f4f7',
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return val
                            },
                        },
                    },
                },
                series: [
                    {
                        name: this.isAdmin ? 'Активные аккаунты' : 'Отвеченные звонки',
                        data: series[1],
                    },
                    {
                        name: this.isAdmin ? 'Неактивные аккаунты' : 'Звонки без ответа',
                        data: series[0],
                    },
                ],
            }
        },
        USERS_STAT_DATA() {
            let data = this.$store.getters['statistics/GET_USERS_STAT_DATA'];

            let qnt_users_all = 0;
            let qnt_users_active = 0;
            let qnt_users_wait = 0;
            let qnt_users_blocked = 0;

            if(data !== null) {
                qnt_users_all = data.qnt_users_all;
                qnt_users_active = data.qnt_users_active;
                qnt_users_wait = data.qnt_users_wait;
                qnt_users_blocked = data.qnt_users_blocked;
            }
            
            return [
                {
                    title: 'Пользователей всего',
                    value: qnt_users_all,
                    icon: 'users',
                    color: 'primary',
                },
                {
                    title: 'Активных',
                    value: qnt_users_active,
                    icon: 'users',
                    color: 'success',
                },
                {
                    title: 'Ожидают активацию',
                    value: qnt_users_wait,
                    icon: 'users',
                    color: 'warning',
                },
                {
                    title: 'Заблокированы',
                    value: qnt_users_blocked,
                    icon: 'users',
                    color: 'danger',
                },
            ]
        },
        SALES_DONUT_CHART() {
            let data = this.$store.getters['statistics/GET_SALES_DONUT_CHART'];

            let colors = [];
            let labels = [];
            let series = [];

            if(data !== null){
                if(data.colors) colors = data.colors;
                if(data.labels) labels = data.labels;
                if(data.values) series = data.values;
            }

            return {
                chartOptions: {
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '60%',
                            },
                            expandOnClick: false,
                        },
                    },
                    colors: colors,
                    legend: {
                        show: true,
                        position: 'right',
                        horizontalAlign: 'left',
                        itemMargin: {
                            horizontal: 6,
                            vertical: 3,
                        },
                    },
                    labels: labels,
                    responsive: [
                        {
                            breakpoint: 480,
                            options: {
                                legend: {
                                    position: 'bottom',
                                },
                            },
                        },
                    ],
                    tooltip: {
                        y: {
                            formatter: (value) => {
                                return value
                            },
                        },
                    },
                },
                series: series,
            }
        },
        TABLE_DATA() {
            let data = this.$store.getters['statistics/GET_TABLE_DATA'];
            let result = [];

            if(data !== null) result = data;

            return result
        },
        session_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user;
        }
    },

    async mounted() {
        let data_send = {}
            
        if(this.session_item.role === 'administrator'){
            this.isAdmin = true;
        } else {
            if (this.session_item.iscompany) {

                if (this.session_item.iscompany === 'false') {
                    this.isCompany = false;
                }
                if (this.session_item.iscompany === 'true') {
                    this.isCompany = true;
                }
            }
        }

        await this.$store.dispatch('statistics/FETCH_DASHBOARD_DATA', data_send);

        this.load = true;
        this.state += 1;
    }
}

</script>

<template>
	<Layout>

		<div class="row page-title align-items-center">
			<div class="col-sm-4 col-xl-6">
				<h4 class="mb-1 mt-0"><i class="feather uil uil-chart-pie-alt"></i>Дашборд</h4>
			</div>
		</div>

        <div v-if="load && !isAdmin" :key="state">

            <div class="row">
                <div class="col-xl-3">
                    <Overview :items="OVERVIEW_DATA" />
                </div>

                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-body pb-0">
                            <h5 class="card-title mb-0 header-title">Расходы</h5>
                            <!-- Revenue Area Chart -->
                            <apexchart
                                type="area"
                                height="296"
                                :series="REVENUE_AREA_CHART.series"
                                :options="REVENUE_AREA_CHART.chartOptions"
                            ></apexchart>
                            <!-- end revenue chart -->
                        </div>
                    </div>
                </div>

                <div class="col-xl-3">
                    <div class="card">
                        <div class="card-body pb-0">
                            <h5 class="card-title header-title">Результативность звонков</h5>
                            <!-- Target Radialbar chart -->
                            <div class="mt-3">
                                <apexchart
                                    type="bar"
                                    height="282"
                                    :series="TARGET_BAR_CHART.series"
                                    :options="TARGET_BAR_CHART.chartOptions"
                                ></apexchart>
                            </div>
                            <!-- end target chart -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-5">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title mt-0 pb-2 header-title">{{'Статистика звонков'}}</h5>
                            <!-- Sales donut chart -->
                            <apexchart
                                type="donut"
                                height="260"
                                :series="SALES_DONUT_CHART.series"
                                :options="SALES_DONUT_CHART.chartOptions"
                            ></apexchart>
                            <!-- end sales chart -->
                        </div>
                    </div>
                </div>
                <div class="col-xl-7">
                    <div class="card">
                        <div class="card-body">
                            <router-link
                                to="/account/finance/payin"
                                class="btn btn-outline-primary btn-sm float-right"
                            >
                                Показать все
                            </router-link>
                            <h5 class="card-title mt-0 mb-0 header-title">Последние платежи</h5>
                            <div class="table-responsive mt-4 mb-0">

                                <b-table-simple class="table table-hover table-nowrap mb-0">
                                    <b-thead class="thead-white">
                                        <b-tr>
                                            <b-th>Дата</b-th>
                                            <b-th>Комментарий</b-th>
                                            <b-th>Сумма</b-th>
                                            <b-th>Статус</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr v-for="item in TABLE_DATA" :key="item.name">
                                            <b-td>{{ item.created_at }}</b-td>
                                            <b-td>{{ item.comments }}</b-td>
                                            <b-td>{{ item.sum }}</b-td>
                                            <b-td>
                                                <span
                                                    class="badge"
                                                    v-bind:class="[
                                                        item.status === 'Отменен' ? 'badge-soft-danger' : '',
                                                        item.status === 'Ожидается' ? 'badge-soft-warning' : '',
                                                        item.status === 'Успешно' ? 'badge-soft-success' : '',
                                                        item.status === 'Заблокирован' ? 'badge-soft-danger' : '',
                                                    ]"
                                                >{{ item.status }}</span
                                                >
                                            </b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="load && isAdmin" :key="state">
            <div class="row">
                <div v-for="stat of USERS_STAT_DATA" :key="stat.title" class="col-md-6 col-xl-3">
                    <Stat
                        :title="stat.title"
                        :value="stat.value"
                        :icon="stat.icon"
                        :color="stat.color"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-xl-3">
                    <Overview :items="OVERVIEW_DATA" />
                </div>
                <div class="col-xl-4">
                    <div class="card">
                        <div class="card-body pb-0">
                            <h5 class="card-title header-title">Активность пользователей</h5>
                            <!-- Target Radialbar chart -->
                            <div class="mt-3">
                                <apexchart
                                    type="bar"
                                    height="282"
                                    :series="TARGET_BAR_CHART.series"
                                    :options="TARGET_BAR_CHART.chartOptions"
                                ></apexchart>
                            </div>
                            <!-- end target chart -->
                        </div>
                    </div>
                </div>
                <div class="col-xl-5">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title mt-0 pb-2 header-title">{{'Статистика звонков'}}</h5>
                            <!-- Sales donut chart -->
                            <apexchart
                                type="donut"
                                height="270"
                                :series="SALES_DONUT_CHART.series"
                                :options="SALES_DONUT_CHART.chartOptions"
                            ></apexchart>
                            <!-- end sales chart -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-body pb-0">
                            <h5 class="card-title mb-0 header-title">Доход общий</h5>
                            <!-- Revenue Area Chart -->
                            <apexchart
                                type="area"
                                height="296"
                                :series="REVENUE_AREA_CHART.series"
                                :options="REVENUE_AREA_CHART.chartOptions"
                            ></apexchart>
                            <!-- end revenue chart -->
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-body pb-0">
                            <h5 class="card-title mb-0 header-title">Доход партнеров</h5>
                            <!-- Revenue Area Chart -->
                            <apexchart
                                type="area"
                                height="296"
                                :series="PARTNERS_COMMISSIONS_AREA_CHART.series"
                                :options="PARTNERS_COMMISSIONS_AREA_CHART.chartOptions"
                            ></apexchart>
                            <!-- end revenue chart -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-body pb-0">
                            <h5 class="card-title mb-0 header-title">Платежи</h5>
                            <!-- Revenue Area Chart -->
                            <apexchart
                                type="area"
                                height="296"
                                :series="PAYMENT_AREA_CHART.series"
                                :options="PAYMENT_AREA_CHART.chartOptions"
                            ></apexchart>
                            <!-- end revenue chart -->
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-body pb-0">
                            <h5 class="card-title mb-0 header-title">Затраты</h5>
                            <!-- Revenue Area Chart -->
                            <apexchart
                                type="area"
                                height="296"
                                :series="EXPENSES_AREA_CHART.series"
                                :options="EXPENSES_AREA_CHART.chartOptions"
                            ></apexchart>
                            <!-- end revenue chart -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</Layout>    
</template>

<style>

text.apexcharts-pie-label {
    color: #000 !important;
}

.card {
    -webkit-box-shadow: 0px 0px 25px 0px rgba(50, 50, 50, 0.10);
    -moz-box-shadow:    0px 0px 25px 0px rgba(50, 50, 50, 0.10);
    box-shadow:         0px 0px 25px 0px rgba(50, 50, 50, 0.10);
    transition: .3s all;
}

.card:hover {
    -webkit-box-shadow: 0px 0px 0px 0px rgba(50, 50, 50, 0);
    -moz-box-shadow:    0px 0px 0px 0px rgba(50, 50, 50, 0);
    box-shadow:         0px 0px 0px 0px rgba(50, 50, 50, 0);
}

</style>